export class RestoreAccountRegions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAccountRegions.attributeTypeMap;
    }
    constructor() {
    }
}
